import { useContext, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import {
  AiOutlineHeart,
  AiOutlineShoppingCart,
  AiOutlineUser,
  AiOutlineClose,
} from "react-icons/ai";
import { MdOutlineLogin } from "react-icons/md";
import { BiSearch } from "react-icons/bi";
import { CiSearch } from "react-icons/ci";
import watchLogo from "../../Assets/watch_ico.png";
import { AuthContext } from "../../Contexts/AuthContext";
import "./Navbar.css";
import { encode, isEmpty, printDebugLog } from "../../Utils/utils";
import { GET, GETWITHOUTVALIDATE } from "../../Network/snpaxios";
import { BILLICON, IMAGE_URL, WEBSITE_SHOP_HASH, WEBSITE_SHOP_NAME } from "../../Utils/constant";
import { SearchproductFilter } from "../global/SearchProductFilter";
import { ProductContext } from "../../Contexts/ProductContext";

const Navbar = () => {
  const { authState } = useContext(AuthContext);
  const { productState } = useContext(ProductContext);
  const token = authState?.mobile;

  const [isSearchBarVisible, setSearchBarVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [listProducts, setListProducts] = useState([]);
  const [navbarLogo, setNavbarLogo] = useState(watchLogo);

  const searchProducts = async (searchQuery) => {
    try {
      const encodedShopHash = encode(WEBSITE_SHOP_HASH);
      const payLoad = await GET(
        `ext/cart/search-item?shopHash=${encodedShopHash}&query=${searchQuery}`
      );

      if (payLoad !== null) {
        setListProducts(payLoad?.fullData || []);
      } else {
        console.error("searchProducts", "null payload");
      }
    } catch (err) {
      console.error("searchProducts", err);
    }
  };

  const handleSearch = async (searchQuery) => {
    printDebugLog("NavBar:handleSearch", searchQuery);

    if (searchQuery.length >= 3) {
      await searchProducts(searchQuery);
    } else {
      setListProducts([]);
    }
  };

  useEffect(() => {
    handleSearch(searchQuery);
  }, [searchQuery])

  useEffect(() => {
    let isMounted = true;

    const loadNavbarLogo = async () => {
      try {
        const query = new URLSearchParams({
          configName: BILLICON,
          shopHash: WEBSITE_SHOP_HASH,
        });
        const configuredBillIcon = await GETWITHOUTVALIDATE(`ext/get-social-configs?${query}`);
        if (isMounted && typeof configuredBillIcon === "string" && !isEmpty(configuredBillIcon)) {
          const isAbsoluteUrl = /^(https?:)?\/\//i.test(configuredBillIcon)
            || configuredBillIcon.startsWith("data:")
            || configuredBillIcon.startsWith("blob:");
          setNavbarLogo(isAbsoluteUrl ? configuredBillIcon : `${IMAGE_URL}${configuredBillIcon}`);
        }
      } catch (error) {
        console.error("Navbar:loadNavbarLogo", error);
      }
    };

    loadNavbarLogo();
    return () => {
      isMounted = false;
    };
  }, []);


  const cartItemQty = productState?.cartIds?.length ?? 0;
  const wishlistItemQty = productState?.wishlistIds?.length ?? 0;

  const toggleSearchBar = () => {
    const pData = !isSearchBarVisible;
    setSearchBarVisible(pData);
    setSearchQuery("");
    setListProducts([]);
  };

  return (
    <nav>
      <div className="logo-container">
        <NavLink to="/" className="nav-link">
          <div className="logo">
            <img
              src={navbarLogo}
              alt={`${WEBSITE_SHOP_NAME || "Shop"} logo`}
              className="logo-icon"
              onError={(event) => {
                event.currentTarget.onerror = null;
                event.currentTarget.src = watchLogo;
              }}
            />
            <span className="logo-name">{WEBSITE_SHOP_NAME}</span>
          </div>
        </NavLink>
      </div>

      <div
        className={`search-container ${isSearchBarVisible ? "search-visible" : ""}`}
      >
        <CiSearch className="search-icon" />

        <SearchproductFilter
          filteredOptions={listProducts}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          onClose={toggleSearchBar}
        />

        {
          isSearchBarVisible && <button className="search-close-btn" onClick={toggleSearchBar}>
            <AiOutlineClose className="close-icon" />
          </button>
        }
      </div>

      <div className="nav-btn-container">
        <button className="nav-link nav-btn" onClick={toggleSearchBar}>
          <BiSearch className="nav-btn-icon" />
        </button>

        <NavLink to="/wishlist" className="nav-link nav-btn">
          <AiOutlineHeart className="nav-btn-icon" />
          {wishlistItemQty !== 0 && (
            <span className="nav-btn-qty">{wishlistItemQty}</span>
          )}
        </NavLink>

        <NavLink to="/cart" className="nav-link nav-btn">
          <AiOutlineShoppingCart className="nav-btn-icon" />
          {cartItemQty !== 0 && (
            <span className="nav-btn-qty">{cartItemQty}</span>
          )}
        </NavLink>

        <NavLink
          to={token ? "/userDetails" : "/login"}
          className="nav-link nav-btn"
        >
          {token ? (
            <AiOutlineUser className="nav-btn-icon" />
          ) : (
            <MdOutlineLogin className="nav-btn-icon" />
          )}
        </NavLink>
      </div>
    </nav>
  );
};

export { Navbar };
